import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { applyChartDefaults } from '@/theme/chartTheme'
import { onColorSchemeChange, syncDocumentColorScheme } from '@/theme/colorScheme'
import './assets/main.css'

syncDocumentColorScheme()
applyChartDefaults()
onColorSchemeChange(() => applyChartDefaults())

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
